import { reactive, readonly } from 'vue'

const state = reactive({
  toasts: [],
  errors: [],
  showErrorModal: false,
})

let toastId = 0

export default function useToast() {
  function addToast(message, type = 'info') {
    state.toasts.push({
      id: toastId++,
      type,
      message,
    })
  }

  function addError(message) {
    addToast(message, 'error')
  }

  function addSuccess(message) {
    addToast(message, 'success')
  }

  function removeToast(id) {
    const index = state.toasts.findIndex((t) => t.id === id)
    if (index > -1) {
      state.toasts.splice(index, 1)
    }
  }

  function clearToasts() {
    state.toasts.length = 0
  }

  function showError(errorObj) {
    state.errors.length = 0
    state.errors.push(errorObj)
    state.showErrorModal = true
  }

  function clearErrors() {
    state.errors.length = 0
    state.showErrorModal = false
  }

  return {
    toasts: readonly(state.toasts),
    errors: readonly(state.errors),
    showErrorModal: state.showErrorModal,
    addToast,
    addError,
    addSuccess,
    removeToast,
    clearToasts,
    showError,
    clearErrors,
  }
}
